import { useState } from 'react';
import { Navbar, Nav, Container, Badge, NavDropdown, Alert, Form, ListGroup, Spinner, Image } from 'react-bootstrap';
import { FaShoppingCart, FaUser } from 'react-icons/fa';
import logo from '../assets/logo.png';
import flavchap_logo from '../assets/flavchap_logo.png';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useLogoutMutation } from '../slices/usersApiSlice';
import { logout } from '../slices/authSlice';
import { resetCart } from '../slices/cartSlice';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useGetAutoCompleteProductsQuery } from '../slices/productsApiSlice';

const Header = () => {
  const { cartItems } = useSelector((state) => state.cart);
  const { userInfo } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      dispatch(logout());
      dispatch(resetCart());
      await logoutApiCall().unwrap();
      
      await signOut(auth);

      localStorage.clear();
      window.location.href = '/login';
    } catch (error) {
      console.log(error);
    }
  }

  const [keyword, setKeyword] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);

  const {
    data: autoCompleteProducts = [],
    isLoading: isLoadingAutoCompleteProducts,
  } = useGetAutoCompleteProductsQuery(
    { keyword },
    { skip: keyword.length < 3 }
  );

  const submitHandler = (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      navigate(`/search/${keyword}`);
      setShowSuggestions(false);
    } else {
      navigate('/');
    }
  };

  return (
    <header>
      <Navbar bg='dark' variant='dark' className='py3 flavchap-main-header'>
        <Container className="d-flex flex-column align-items-center gap-3">
          <div className='d-flex flex-wrap justify-content-center align-items-center gap-3 w-100'>
            <Link to='/'>
              <Navbar.Brand className="text-center">
                <img src={flavchap_logo} className="img-fluid flavchap-logo mx-2" alt='Flavchap Logo'/>
                <img src={logo} className="img-fluid logo" alt='Telugu Pindi Vantalu Logo'/>
              </Navbar.Brand>
            </Link>
            <div className="text-center position-relative" style={{ maxWidth: '500px', width: '100%' }}>
              <Form onSubmit={submitHandler} className="position-relative">
                <div className="d-flex align-items-center position-relative">
                  <Form.Control
                    type="text"
                    name="q"
                    placeholder="Search products..."
                    value={keyword}
                    onChange={(e) => {
                      const val = e.target.value;
                      setKeyword(val);
                      if (val.trim().length >= 3) {
                        setShowSuggestions(true);
                      } else {
                        setShowSuggestions(false);
                      }
                    }}
                  />
                  {isLoadingAutoCompleteProducts && (
                    <Spinner
                      animation="border"
                      size="sm"
                      className="position-absolute end-0 me-2"
                    />
                  )}
                </div>

                {showSuggestions && autoCompleteProducts.length > 0 && (
                  <ListGroup className="position-absolute w-100 shadow mt-1 z-3">
                    {autoCompleteProducts.map((p) => (
                      <ListGroup.Item
                        key={p._id}
                        action
                        onClick={() => {
                          setKeyword('');
                          setShowSuggestions(false);
                          navigate(`/product/${p._id}`)
                        }}
                      >
                        {p.image && (
                          <Image
                            src={p.image}
                            alt={p.name}
                            rounded
                            className="me-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />
                        )} {p.name}
                        <div className="flex-grow-1">
                          {p.alternateNames && (
                            <small className="text-muted">{p.alternateNames}</small>
                          )}
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                )}
              </Form>
            </div>
          </div>
          <Nav className='d-flex flex-wrap justify-content-center gap-3 w-100'>
            <NavDropdown title="About" id="about">
              <NavDropdown.Item as={Link} to='/about'>
                About Us
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to='/contact'>
                Contact Us
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={Link} to='/cart'>
              <FaShoppingCart/> Cart
                {
                  cartItems.length > 0 && (
                    <Badge pill bg='success' style={{marginLeft:'1em'}}>
                      { cartItems.reduce((acc, curr) => acc + curr.quantity, 0) }
                    </Badge>
                  )
                }
            </Nav.Link>
            {userInfo ? (
              <NavDropdown title={<><FaUser/> {userInfo.name}</>} id='username'>
                <NavDropdown.Item as={Link} to='/profile'>
                  Profile & Orders
                </NavDropdown.Item>
                <NavDropdown.Item onClick={logoutHandler}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link as={Link} to='/login' onClick={(e) => {
                e.preventDefault();
                window.location.href = '/login'; // force full reset
              }}>
                <FaUser/> Sign In
              </Nav.Link>
            )}
            { userInfo && userInfo.isAdmin && (
              <NavDropdown title="Admin Functions" id="adminmenu">
                <NavDropdown.Item as={Link} to="/admin/whatsapp">
                  WhatsApp
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/admin/productlist">
                  Products
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/admin/userlist">
                  Users
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/admin/orderlist">
                  Orders
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>
        </Container>
      </Navbar>

      {(userInfo?.name === "User" || userInfo?.name === "user") && (
        <Alert variant="info" className="text-center m-0 py-2">
          <Link to="/profile" className="text-info fw-bold text-decoration-none">
            Please update your name for better customer experience
          </Link>
        </Alert>
      )}
    </header>
  )
}

export default Header